import type { ReportSchema } from '@ballerine/common';
import React from 'react';
import type { z } from 'zod';

import { GoogleMapsView } from '@/components/templates/shared/AddressComponents/GoogleMapsView';
import { DFMerchantDetailsContent } from './DFMerchantDetailsContent';

type MerchantDetailsSectionProps = {
  merchantDetails: NonNullable<z.infer<typeof ReportSchema>['data']>['merchantDetails'];
  googleMapsApiKey: string;
};

export const MerchantDetails: React.FC<MerchantDetailsSectionProps> = ({
  merchantDetails,
  googleMapsApiKey,
}) => {
  return (
    <div className="mb-6 rounded-2xl bg-white pt-10">
      <div className="flex gap-6">
        <div className="w-3/5 flex flex-col">
          <h2 className="text-xl font-semibold mb-6 text-slate-800">Merchant Details</h2>
          <DFMerchantDetailsContent merchantDetails={merchantDetails} />
        </div>
        <div className="w-2/5">
          <GoogleMapsView
            address={merchantDetails?.address}
            countryCode={undefined}
            googleMapsApiKey={googleMapsApiKey}
            className="h-80"
          />
        </div>
      </div>
    </div>
  );
};
